<table
 (matSortChange)="onSortChange($event)"

  [dataSource]="dataSource"
  
  mat-table
  matSort
  style="width: 100%"
>
<!-- <ng-container matColumnDef="action">
  <th *matHeaderCellDef mat-header-cell mat-sort-header>
   N°
  </th>
  <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
</ng-container> 

<ng-container matColumnDef="lawClCd">
  <th *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "lawClCd" | translate }}
  </th>
  <td *matCellDef="let d" mat-cell>{{ d.lawClCd }}</td>
</ng-container>
-->

<ng-container matColumnDef="cdNm">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ "cdNm" | translate }}
    </th>
    <td *matCellDef="let d" mat-cell>{{ d.cdNm }}</td>
  </ng-container>

  <ng-container matColumnDef="cdNmFr">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ "cdNm" | translate }}
    </th>
    <td *matCellDef="let d" mat-cell>{{ d.cdNmFr }}</td>
  </ng-container>

  <ng-container matColumnDef="cdNmAr">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ "cdNm" | translate }}
    </th>
    <td *matCellDef="let d" mat-cell>{{ d.cdNmAr }}</td>
  </ng-container>


<ng-container matColumnDef="title">
  <th  *matHeaderCellDef mat-header-cell mat-sort-header>
   
    {{ "title1" | translate }}
  </th>
  <td  *matCellDef="let d" mat-cell>
     <a [routerLink]="['/portail/public-buyer-announcements/details']"  [queryParams]="{ id: d.ptNoticeInstId }" class="st-p" >
     {{ d.title }}</a>
    </td>
</ng-container>

<ng-container matColumnDef="instNm">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ "instNm" | translate }}
    </th>
    <td *matCellDef="let d" mat-cell>{{ d.instNm }}</td>
  </ng-container>


<ng-container matColumnDef="moderNm">
  <th *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "moderNm" | translate }}
  </th>
  <td *matCellDef="let d" mat-cell>{{ d.writerNm }}</td>
</ng-container>


<ng-container matColumnDef="modDt">
  <th *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "modDt" | translate }}
  </th>
  <td class="text-center" *matCellDef="let d" mat-cell>{{ d.modDt | date : 'dd/MM/yyyy' }}</td>
</ng-container>


<ng-container matColumnDef="hitCnt">
  <th *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "hitCnt" | translate }}
  </th>
  <td class="text-center" *matCellDef="let d" mat-cell>{{ d.hitCnt }}</td>
</ng-container>

  <tr  *matHeaderRowDef="getcol()" mat-header-row></tr>
  <tr  *matRowDef="let row; columns: getcol()" mat-row></tr> 
  
   


  
</table>
<app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
